<div class="row"
  *ngIf="chartData?.datasets?.length">
  <div class="col py-5">
    <div class="insights-chart">
      <hero-chart [chartData]="chartData"
        [chartOptions]="chartOptions"
        [plugins]="plugins"></hero-chart>
    </div>
  </div>
</div>